import { FuelType } from '../types';

/**
 * Single source of truth for how each generator fuel type is presented in the
 * UI: the emoji shown on DAG nodes and in the generator-table selector, and the
 * human-readable label.
 */
export const FUEL_TYPES: FuelType[] = ['fossil', 'wind', 'solar'];

const FUEL_TYPE_ICONS: Record<FuelType, string> = {
  fossil: '🔥',
  wind: '💨',
  solar: '☀️',
};

const FUEL_TYPE_LABELS: Record<FuelType, string> = {
  fossil: 'Fossil',
  wind: 'Wind',
  solar: 'Solar',
};

/**
 * Emoji for a generator's fuel type. Falls back to a generic "G" when the fuel
 * type is unset (e.g. a generator with no fuelType assigned).
 */
export function getFuelIcon(fuelType?: FuelType): string {
  return fuelType ? FUEL_TYPE_ICONS[fuelType] : 'G';
}

/**
 * Human-readable label for a generator's fuel type.
 */
export function getFuelLabel(fuelType: FuelType): string {
  return FUEL_TYPE_LABELS[fuelType];
}
